module.exports = __webpack_public_path__ + "static/media/conference.af7abc5b.svg";